import { render, staticRenderFns } from "./ClientHistoryTeamComponent.vue?vue&type=template&id=27f17ce6&"
import script from "./ClientHistoryTeamComponent.vue?vue&type=script&lang=js&"
export * from "./ClientHistoryTeamComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports